<template>
    <div class="vue-drupal-view-filter-dropdown">
        <v-select
            v-model="selected"
            :multiple="true"
            :close-on-select="false"
            :options="computedItems"
            :reduce="item => item.code"
            :placeholder="label"
        ></v-select>
    </div>
</template>

<script>
export default {
    name: "DrupalViewFilterDropdown",

    props: {
        items: {},
        slug: {},
        preSelected: {},
        dateFilters: {},
        label: {},
        isResultPage: {},
        isLocationPage: {},
    },

    data() {
        return {
            selected: null,
        }
    },

    computed: {
        computedItems() {
            return _.sortBy(_.map(this.items, (value, key) => {
                return {
                    code: key,
                    label: value,
                }
            }), (item) => item.label);
        }
    },

    created() {
        if (!_.isNil(this.preSelected) && !this.isResultPage) {
            this.selected = this.preSelected
        }

        if (!_.isNil(this.preSelected) && (this.isResultPage || this.isLocationPage)) {
            this.selected = _.keys(this.preSelected)
        }
    },

    watch: {
        selected() {
            this.$emit('filter-changed', {
                slug: this.slug,
                items: this.selected,
            })
        }
    }
}
</script>